import { BlockNoteEditor } from '@/components/atoms/BlockNoteEditor/BlockNoteEditor';
import { Option } from '@/shared/types/rules';
import '@blocknote/shadcn/style.css';
import './CampaignRichEditor.scss';

interface CampaignRichEditorProps {
  /** Markdown content to display in the editor */
  content: string;
  /** Callback when content changes, receives Markdown string */
  onContentChange: (content: string) => void;
  /** Available context variables for autocomplete */
  variableOptions: Option[];
  /** Placeholder text for empty editor */
  placeholder?: string;
  /** Additional CSS classes */
  className?: string;
  /** Maximum content length */
  maxLength?: number;
  /** Slash menu item keys to show (defaults to headings, paragraph, lists) */
  allowedSlashKeys?: string[];
  /** Block type dropdown keys to show in the formatting toolbar */
  allowedBlockTypeKeys?: string[];
}

/**
 * Campaign rich text editor wrapper
 * Configured for comprehensive formatting with full toolbar and all block types
 */
const DEFAULT_SLASH_KEYS = [
  'heading',
  'heading_2',
  'heading_3',
  'toggle_heading',
  'toggle_heading_2',
  'toggle_heading_3',
  'paragraph',
  'numbered_list',
  'bullet_list',
];

export function CampaignRichEditor({
  content,
  onContentChange,
  variableOptions,
  placeholder = '',
  className = '',
  maxLength,
  allowedSlashKeys = DEFAULT_SLASH_KEYS,
  allowedBlockTypeKeys,
}: CampaignRichEditorProps) {
  return (
    <BlockNoteEditor
      content={content}
      onContentChange={onContentChange}
      variableOptions={variableOptions}
      placeholder={placeholder}
      formattingButtons={['bold', 'italic', 'link', 'blockType']}
      allowedSlashKeys={allowedSlashKeys}
      allowedBlockTypeKeys={allowedBlockTypeKeys}
      maxLength={maxLength}
      enforceMaxLength={true}
      className={`campaign-rich-editor ${className}`.trim()}
    />
  );
}
